"use strict";

exports.__esModule = true;
exports.isServicePayable = exports.isServiceOfferedAsPricingPlan = exports.isServiceHasPricingPlanError = exports.isServiceConnectedToPricingPlan = exports.getPaymentDescription = exports.getFormattedCurrency = void 0;
var _types = require("@wix/ambassador-bookings-services-v2-service/types");
const getPaymentDescription = ({
  payment,
  regionalSettingsLocale,
  paymentFormatters,
  paymentSeparator = ' | ',
  currencyDisplay = 'symbol'
}) => {
  const {
    rateType,
    pricingPlanIds,
    options
  } = payment;
  const paymentDescriptions = [];
  if (rateType === _types.RateType.CUSTOM) {
    var _payment$custom;
    paymentDescriptions.push((_payment$custom = payment.custom) == null ? void 0 : _payment$custom.description);
  } else if (rateType === _types.RateType.FIXED) {
    var _payment$fixed, _payment$fixed2;
    paymentDescriptions.push(getFormattedCurrency({
      price: (_payment$fixed = payment.fixed) == null || (_payment$fixed = _payment$fixed.price) == null ? void 0 : _payment$fixed.value,
      locale: regionalSettingsLocale,
      currency: (_payment$fixed2 = payment.fixed) == null || (_payment$fixed2 = _payment$fixed2.price) == null ? void 0 : _payment$fixed2.currency,
      currencyDisplay
    }));
  } else if (rateType === _types.RateType.VARIED) {
    const {
      minPrice,
      maxPrice
    } = payment.varied;
    const formattedMinPrice = getFormattedCurrency({
      price: minPrice == null ? void 0 : minPrice.value,
      locale: regionalSettingsLocale,
      currency: minPrice == null ? void 0 : minPrice.currency,
      currencyDisplay
    });
    const formattedMaxPrice = getFormattedCurrency({
      price: maxPrice == null ? void 0 : maxPrice.value,
      locale: regionalSettingsLocale,
      currency: maxPrice == null ? void 0 : maxPrice.currency,
      currencyDisplay
    });
    paymentDescriptions.push(paymentFormatters.variedPrice({
      minPrice: formattedMinPrice,
      maxPrice: formattedMaxPrice
    }));
  }
  if (paymentFormatters.pricingPlans && options != null && options.pricingPlan && pricingPlanIds != null && pricingPlanIds.length) {
    paymentDescriptions.push(paymentFormatters.pricingPlans({
      hasAnotherPaymentDescription: paymentDescriptions.length > 0
    }));
  }
  return paymentDescriptions.join(paymentSeparator);
};
exports.getPaymentDescription = getPaymentDescription;
const getFormattedCurrency = ({
  price,
  currencyDisplay = 'symbol',
  locale,
  currency
}) => {
  if (typeof price === 'string') {
    price = Number(price);
  }
  const fractionDigits = price % 1 === 0 ? 0 : 2;
  return Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay,
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits
  }).format(Number(price));
};
exports.getFormattedCurrency = getFormattedCurrency;
const isServiceOfferedAsPricingPlan = ({
  payment
}) => {
  var _payment$options;
  return !!(payment != null && (_payment$options = payment.options) != null && _payment$options.pricingPlan);
};
exports.isServiceOfferedAsPricingPlan = isServiceOfferedAsPricingPlan;
const isServicePayable = ({
  payment
}) => {
  var _payment$options2, _payment$options3;
  return (payment == null || (_payment$options2 = payment.options) == null ? void 0 : _payment$options2.online) || (payment == null || (_payment$options3 = payment.options) == null ? void 0 : _payment$options3.inPerson);
};
exports.isServicePayable = isServicePayable;
const isServiceHasPricingPlanError = ({
  payment,
  isPricingPlanInstalled
}) => {
  return isServiceOfferedAsPricingPlan({
    payment
  }) && !isServicePayable({
    payment
  }) && (!isPricingPlanInstalled || !isServiceConnectedToPricingPlan({
    payment
  }));
};
exports.isServiceHasPricingPlanError = isServiceHasPricingPlanError;
const isServiceConnectedToPricingPlan = ({
  payment
}) => {
  var _payment$pricingPlanI;
  return !!(payment != null && (_payment$pricingPlanI = payment.pricingPlanIds) != null && _payment$pricingPlanI.length);
};
exports.isServiceConnectedToPricingPlan = isServiceConnectedToPricingPlan;
//# sourceMappingURL=payment.js.map